export default function Loader({ marginData }) {
  return (
    <div
      style={{ marginTop: marginData }}
      className="mx-auto animate-spin w-8 h-8 border-4 border-blue-300 border-t-blue-700 rounded-full"
    ></div>
  );
}
